import './App.css';
import Quotes from './Quotes';
import tomato from './tomato.png';
import Period from './Period';
import Time from './Time';
import Countdown from './countdown';
import FiveTimer from './FiveTimer';
import Settings from './Settings';
import Coins from './Coins';
import SliderContainer from './SliderContainer';
import ButtonToStartTimer from './ButtonToStartTimer';
import { useState } from 'react';

function App() {
  const [period, setPeriod] = useState(1);
  return (
    <center className="App">
      <h1>
        <Settings />
        <Coins />

        <img src={tomato} className="logo"></img>
        <ButtonToStartTimer period={period} />

        <Time />
      </h1>
    </center>
  );
}

export default App;
